import Image from "next/image"
import { RANK_LABELS, type BadgeRank } from "@/lib/badges/types"
import { cn } from "@/lib/utils"

interface BadgeIconProps {
  slug: string
  rank: BadgeRank
  size?: "xs" | "sm" | "base" | "md" | "lg" | "xl"
}

const SIZE_MAP = {
  xs:   { box: "h-5 w-5",         px: 20  },
  sm:   { box: "h-6 w-6",         px: 24  },
  base: { box: "h-8 w-8",         px: 32  },
  md:   { box: "h-10 w-10",       px: 40  },
  lg:   { box: "h-16 w-16",       px: 64  },
  xl:   { box: "h-[170px] w-[170px]", px: 170 },
}

export function BadgeIcon({ slug, rank, size = "md" }: BadgeIconProps) {
  const dims = SIZE_MAP[size]

  return (
    <div
      className={cn("relative rounded-lg shrink-0 overflow-hidden", dims.box)}
      title={RANK_LABELS[rank]}
    >
      <Image
        src={`/badges/${slug}_r${rank}.webp`}
        alt=""
        fill
        sizes={`${dims.px}px`}
        className="object-contain"
      />
    </div>
  )
}
